import React from "react"
import { useStaticQuery, graphql } from "gatsby"
// import classNames from "classnames"
import logo from "images/mado-logo.svg"
// import desktopLogo from 'images/desktop-logo.png'
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { media } from 'utils/Media'
// import logoStacked from "images/logo-stacked.svg"

const StyledLogo = styled.div`
	display: inline-block;
	.mobile {
		@media ${media.xl} {
			display: none;
		}
	}
	.desktop {
		display: none;
		@media ${media.xl} {
			width: 100%;
			display: block;
			img {
				width: auto;
				height: auto;
				max-width: 400px;
			}
		}
		@media ${media.xxl} {
			img {
				max-width: 500px;
			}
		}
	}
`

const Logo = () => {
	const data = useStaticQuery(graphql`
		query LogoQuery {
			site {
				siteMetadata {
					title
				}
			}
		}
	`)
	
	return(
		<StyledLogo>
			{/* <div className="mobile"> */}
				<img src={logo} alt={data.site.siteMetadata.title} />
			{/* </div> */}
			{/* <div className="desktop">
				<img src={desktopLogo} alt={data.site.siteMetadata.title} />
			</div> */}
			{/* {props.stacked &&
					<img src={logoStacked} alt={data.site.siteMetadata.title} className="d-md-none" />
			} */}
		</StyledLogo>
	)
}

Logo.defaultProps = {
  stacked: false
}


export default Logo
